import {
    fetchMonitoredDocumentCompareAction,
    setMonitoredDocumentActiveStatusAction,
    setMonitoredDocumentValidatedAction,
} from '../../state/actions/MonitoredDocumentActions';

import Component from './MonitoredDocumentCompare.component.jsx';
import { connect } from 'react-redux';
import { createDocumentAnalysisAction } from '../../state/actions/DocumentActions';
import fromState from '../../state/selectors';
import { setDocumentMonitoringStatusAction } from '../../state/actions/DocumentActions';

const md = require('markdown-it')({ html: true }).use(require('markdown-it-sanitizer'));

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    return {
        fetching: fromState.MonitoredDocumentCompare.isFetching(state),
        fetched: fromState.MonitoredDocumentCompare.isFetched(state),
        failed: fromState.MonitoredDocumentCompare.hasFailed(state),
        monitoredDocumentCompare:
            fromState.MonitoredDocumentCompare.getMonitoredDocumentCompare(state),
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        fetchMonitoredDocumentCompare: () =>
            dispatch(
                fetchMonitoredDocumentCompareAction(
                    ownProps.documentId,
                    ownProps.oldVersionId,
                    ownProps.newVersionId
                )
            ),
        setMonitoredDocumentValidated: (significant, comment) =>
            dispatch(
                setMonitoredDocumentValidatedAction(
                    ownProps.documentId,
                    ownProps.newVersionId,
                    significant,
                    comment
                )
            ),
        createDocumentAnalysis: () =>
            dispatch(createDocumentAnalysisAction(ownProps.documentId, 100)),
        setDocumentMonitoringStatus: () =>
            dispatch(setDocumentMonitoringStatusAction(ownProps.documentId, false)),
        setMonitoredDocumentActiveStatus: () =>
            dispatch(setMonitoredDocumentActiveStatusAction(ownProps.documentId, false)),
    };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    let oldHtml = null;
    let newHtml = null;

    const { monitoredDocumentCompare } = stateProps;

    if (
        monitoredDocumentCompare &&
        monitoredDocumentCompare.oldVersion &&
        monitoredDocumentCompare.newVersion &&
        monitoredDocumentCompare.oldVersion.markdown &&
        monitoredDocumentCompare.newVersion.markdown
    ) {
        oldHtml = md.render(monitoredDocumentCompare.oldVersion.markdown);
        console.log('oldHtml', oldHtml);
        newHtml = md.render(monitoredDocumentCompare.newVersion.markdown);
        console.log('newHtml', newHtml);
    }

    return {
        ...ownProps,
        ...stateProps,
        onInitialLoad: dispatchProps.fetchMonitoredDocumentCompare,
        setMonitoredDocumentValidated: dispatchProps.setMonitoredDocumentValidated,
        createDocumentAnalysis: dispatchProps.createDocumentAnalysis,
        setDocumentMonitoringStatus: dispatchProps.setDocumentMonitoringStatus,
        setMonitoredDocumentActiveStatus: dispatchProps.setMonitoredDocumentActiveStatus,
        oldHtml: oldHtml,
        newHtml: newHtml,
    };
};

// EXPORT CONTAINER
export default connect(mapStateToProps, mapDispatchToProps, mergeProps, { forwardRef: true })(
    Component
);
